import instituicaoFinanceiraList from '../instituicaoFinanceiraList'



const administradoraConsorcioList = (simulacaoConsorcio) => {

    return instituicaoFinanceiraList.filter(linhaInstituicaoFinanceiraList =>
        linhaInstituicaoFinanceiraList.administradoraConsorcio === 'S' &&
            (!simulacaoConsorcio || (simulacaoConsorcio && linhaInstituicaoFinanceiraList.SvgConsorcioLogo)))
}

export default administradoraConsorcioList